import React from 'react';
import {useTranslation} from '../use-translation';
import {useComponent} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {PayloadPeopleValues} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

interface PayloadPeopleToggleProps {
  questionTextId: string;
  value: PayloadPeopleValues;
  onChange: (newValue: PayloadPeopleValues) => void;
  id: string;
  testId?: string;
}

export const PayloadPeopleToggle = React.memo(function PayloadPeopleToggle({
  questionTextId,
  onChange,
  id,
  value,
  testId,
}: PayloadPeopleToggleProps): JSX.Element {
  const translations = useTranslation();

  const optionOne = {
    value: PayloadPeopleValues.one,
    label: translations.inputSection.passengersOptions.labelOne,
  };
  const optionMultiple = {
    value: PayloadPeopleValues.multiple,
    label: translations.inputSection.passengersOptions.labelMultiple,
  };

  const Toggle = useComponent('Toggle');

  return (
    <Toggle
      value={value}
      options={[optionOne, optionMultiple]}
      id={id}
      onChange={(newValue) => onChange(newValue as PayloadPeopleValues)}
      labelId={questionTextId}
      testId={testId}
    />
  );
});

PayloadPeopleToggle.displayName = 'PayloadPeopleToggle';
